import { combineReducers } from 'redux'

import userReducer from './user'
import navReducer from './nav'
import surveyReducer from './surveys'

export default combineReducers({user: userReducer, nav: navReducer, survey: surveyReducer})